export default __webpack_public_path__ + "static/media/SettingsNew.2be92945.svg";